// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from 'react'
// import PropTypes from 'prop-types'
import { css } from 'glamor'
import { graphql } from 'gatsby'

import map from 'lodash/map'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import AnchorLink from 'react-anchor-link-smooth-scroll'

import keygen from '@bodhi-project/components/lib/methods/keygen'
import Image from '@bodhi-project/components/lib/Image'
import Img from 'gatsby-image'

import Division from '@bodhi-project/components/lib/Division'
import '@bodhi-project/antrd/lib/wonky/3.16.2/row/style/css'
import '@bodhi-project/antrd/lib/wonky/3.16.2/col/style/css'

import Button from 'antd/lib/button'
import '@bodhi-project/antrd/lib/wonky/3.16.2/button/style/css'

import Grid from '@bodhi-project/components/lib/gatsby-image/Grid'
import '@bodhi-project/antrd/lib/wonky/3.16.2/card/style/css'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import Link from '../components/Link'
import HomePage from '../components/wrappers/HomePage'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { Fragment } = React
const pageData = {
    pageTitle: 'PISA Based Test Platform',
    nakedPageSlug: '',
    pageAbstract: "PISA Master is a PISA-based test platform which consists of cognitive assessment and preparatory tests and surveys for PISA-test readiness. The platform provides a digital environment for item development to end-users (schools & teachers) and an 'on demand' digital delivery of sample tests to the test-takers.",
}

/** toDegrees */
const toDegrees = angle => angle * (Math.PI / 180)

const menu = [{
        title: 'About',
        link: '#about',
        symbol: 'about',
    },
    {
        title: 'Certified Trainers',
        link: '#certified-trainers',
        symbol: 'certifiedTrainers',
    },
    {
        title: 'Certification Weave',
        link: '#certification-weave',
        symbol: 'certificationWeave',
    },
    {
        title: 'Events',
        link: '#events',
        symbol: 'events',
    },
    {
        title: 'Contact Us',
        link: '#contact-us',
        symbol: 'contactUs',
    },
]

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Images
// ----------------------------------------------------------------------------
export const query = graphql `
  query {
    banner: file(relativePath: { eq: "banner.png" }) {
      ...defaultImage
    }
    technology: file(relativePath: { eq: "technology.png" }) {
      ...defaultImage
    }
    aligned: file(relativePath: { eq: "aligned.png" }) {
      ...defaultImage
    }
    features: file(relativePath: { eq: "features.png" }) {
      ...defaultImage
    }
    community: file(relativePath: { eq: "community.png" }) {
      ...defaultImage
    }
  }
`

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
const style = css({
    '& .child-circle': {
        width: 100,
        height: 100,
        borderRadius: '50%',
        position: 'absolute',
        left: 187.5,
        top: 187.5,
        // transition: 'all 300ms ease-in',
        cursor: 'pointer',
        display: 'block',

        '&::after': {
            content: `attr(data-text)`,
            fontWeight: 500,
            fontSize: '16px',
            color: '#e15700',
            width: 100,
            textAlign: 'center',
            position: 'absolute',
            fontFamily: 'baileywick-jf-gothic, sans-serif',
        },
    },

    '& .trainers': {
        '& .card': {
            border: '2px solid #285BA1',
            boxShadow: 'unset !important',
        },

        '& .ant-card-body': {
            padding: '0.3rem !important',
        },
    },
}).toString()

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
 *
 */
class Page extends React.Component {
    /** standard constructor */
    constructor(props) {
        super(props)
    }

    /** standard renderer */
    render() {
        return (
            <HomePage pageData={pageData} {...this.props} className={style}>
        <Division golden>
          <div>
            <Img fluid={this.props.data.banner.childImageSharp.fluid} />
          </div>
          <div>
            <h1>Get Ready For PISA</h1>
            <p className="copy">
              <span className="big-hero">
                Cognitive assessment and preparatory tests and surveys for
                PISA-test readiness.
              </span>
            </p>
            <p>
              Programme for International Student Assessment (PISA) 2018 was the
              seventh round of the international assessment since the programme
              was launched in 2000. Every PISA test assesses students' knowledge and skills in reading, mathematics and science; each assessment 
              focuses on one of these subjects and provides a summary assessment
              of the other two.
            </p>
            <p>
              Over ten million students represented by PISA in 2018 in which
              15-year-olds living in the 79 high- and middle-income countries
              that participated in the test.
            </p>
            <p>
              PISA is broadening the range of outcomes: 2018 - global
              competency; 2021 - creative thinking; 2024 - learning in digital
              world.
            </p>
          </div>
        </Division>
        <br />
        <br />
        <br />
        <br />
        <div
          style={{
            background: '#fafafa',
            boxShadow: '1px 1px 4px #fffcec',
            position: 'relative',
            marginBottom: 30,
            padding: '2rem',
            minHeight: '38vh',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div style={{ margin: 'auto' }}>
            <h2
              className="shadow"
              data-shadow="How PISA-Based Test Platform is important for your education system?"
              id="about"
            >
              How PISA-Based Test Platform is important for your education
              system?
            </h2>
            <p
              className="copy"
              style={{ marginLeft: 'auto', marginRight: 'auto' }}
            >
              <span className="hero">
                We offer you a Competency-Based Education platform that provides
                a digital environment for item development and digital delivery
                of PISA-style preparatory tests to the test-takers for the
                Programme for International Student Assessment. The system
                provides an instantaneous feedback on performance. An AI-powered
                recommendation engine shall alert on progress and areas that
                require attention.
              </span>
            </p>
            <p>
              The platform also addresses a high-quality instructions
              management, equitable learning opportunity for all users, and an
              efficient environment that nurtures students' well-being. It also
              enables efficient resource utilization by continuous supply of
              skills that fuel the future economic growth and promote social
              cohesion.'
            </p>
            <p>
              <strong>
                Quality of schools will feed into economics of tomorrow!
              </strong>
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <div
          style={{
            background: '#f5fcf5',
            boxShadow: '1px 1px 4px #baeaba',
            position: 'relative',
            padding: '2rem',
            minHeight: '33vh',
          }}
        >
          <div style={{ maxWidth: '70rem', margin: 'auto' }}>
            <br />
            <br />
            <br />
            <br />
            <Division golden>
              <div className="copy">
                <h2>Key Requirements for Competency-Based Systems</h2>
                <ul className="mask-p">
                  <li>High Quality Instructions; </li>
                  <li>Aligning Education with Career Aspirations; </li>
                  <li>
                    Nurturing School Life, Student Life, and Student Well-Being;{' '}
                  </li>
                  <li>Fostering Growth Mindset; </li>
                  <li>Equitable Learning Opportunity for all.</li>
                </ul>
              </div>
              <div>
                <Img fluid={this.props.data.features.childImageSharp.fluid} />
              </div>
            </Division>
            <br />
            <br />
            <br />
            <br />
            <Division golden>
              <div className="copy">
                <h2>Alignment with main PISA test</h2>
                <ul className="mask-p">
                  <li>
                    Includes a growing item bank on Collaborative Problem
                    Solving, Financial Literacy, Reading, Science and
                    Mathematics
                  </li>
                  <li>PISA Comparability</li>
                  <li>PISA Scale</li>
                  <li>PISA proficiency level distribution</li>
                  <li>Powerful Feedback System</li>
                  <li>Digital Reporting Dashboard</li>
                </ul>
              </div>
              <div>
                <Img fluid={this.props.data.aligned.childImageSharp.fluid} />
              </div>
            </Division>
            <br />
            <br />
            <br />
            <br />
            <Division golden>
              <div className="copy">
                <h2>Technology</h2>
                <ul className="mask-p">
                  <li>High availability</li>
                  <li>Advanced Technology Platform</li>
                  <li>Standards driven</li>
                  <li>WCAG Accessibility Compliant</li>
                  <li>Help desk</li>
                  <li>Data Privacy - GDPR</li>
                </ul>
              </div>
              <div>
                <Img fluid={this.props.data.technology.childImageSharp.fluid} />
              </div>
            </Division>
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <div
          style={{
            background: '#fafafa',
            boxShadow: '1px 1px 4px #fffcec',
            position: 'relative',
            marginBottom: 30,
            padding: '2rem',
            minHeight: '38vh',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div style={{ margin: 'auto' }}>
            <Img
              fluid={this.props.data.community.childImageSharp.fluid}
              style={{ maxWidth: 400, margin: 'auto' }}
            />
            <h2 className="shadow" data-shadow="Community" id="about">
              Why we exist?
            </h2>
            <p
              className="copy"
              style={{ marginLeft: 'auto', marginRight: 'auto' }}
            >
              <span className="hero">
                <p>
                  The contemporary world faces a radical crisis
                  today.Inequality, poverty, environmental degradation, human
                  rights abuse, global warming, unsustainable resource
                  depletion, illiteracy, lack of access to education, woefully
                  inadequate health care and brutal conflicts continue to plague
                  the world in undiminished ways.Human suffering and ecological
                  damage have reached unprecedented and terrifying levels.This
                  is the world that our children will inherit from us.It is in
                  such times and circumstances that something new must come.
                </p>
                <p>
                  <b>About Us:</b> The "Competency Systems" team is crafted out
                  of its parent company, Digital Media Initiatives. It is a
                  small, close-knit and formidable team with expertise in the
                  domains of technology, design, teaching, marketing, finance,
                  management and core banking. Our passion for quality,
                  aesthetics and social transformation informs what we do every
                  day, whether it's building innovative technology tools,
                  connecting with communities, or dreaming up new things.
                </p>
                <p>
                  Connect with us: <b>hello (@) dmi.systems</b>
                </p>
              </span>
            </p>
          </div>
        </div>
      </HomePage>
        )
    }
}

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default Page